const primaryColour = "#3F4B6C";
export default primaryColour;
